import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import redraw from './modules/redraw'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    redraw
  },
  getters
})

export default store
export const useStore = () => store
